import { Add, Delete } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import InputImageCell from "./InputImageCell";
import InputCell from "./InputCell";
import React from "react";
import { Product } from "../../../../types/Product";

const TabProducts = ({
  products,
  setProducts,
}: {
  selectValue: string;
  allProducts: any;
  products: Product[];
  setProducts: (products: Product[]) => void;
}) => {
  const handleProductChange = (id: string, key: string, value: any) => {
    const newProducts = products.map((product: any) => {
      if (product.id === id) {
        return { ...product, [key]: value };
      }
      return product;
    });
    setProducts(newProducts);
  };
  const addProduct = () => {
    const newProduct = {
      id: Date.now().toString(),
      name: "New Product",
      price: 0,
      image: "",
    };
    const newProducts = [...products, newProduct];
    setProducts(newProducts);
  };
  const saveProducts = async (products: any[]) => {
    console.log("Saving products", products);

    const toBase64FromUrl = async (url: string) => {
      if (!url) return url;
      if (url.startsWith("data:")) return url;
      if (url.startsWith("http")) return url;
      try {
        const res = await fetch(url);
        const blob = await res.blob();
        const base64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
        // revoke object URL if it was a blob URL
        if (url.startsWith("blob:")) {
          try {
            URL.revokeObjectURL(url);
          } catch (e) {
            /* ignore */
          }
        }
        return base64;
      } catch (e) {
        console.error("Failed to convert image to base64:", e);
        return url;
      }
    };

    const converted = await Promise.all(
      products.map(async (product) => {
        let newProduct = { ...product };
        if (product.image) {
          const convertedImage = await toBase64FromUrl(product.image);
          newProduct.image = convertedImage;
        }
        if (!product.price) {
          newProduct.price = 0;
        }
        return newProduct;
      }),
    );

    console.log("Final products to save", converted);
    // save products to localStorage
    setProducts(converted);
    alert("儲存成功");
  };
  return (
    <>
      <Box
        mb={1}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h6">商品列表</Typography>
          <IconButton
            onClick={addProduct}
            size="small"
            aria-label="add product"
          >
            <Add />
          </IconButton>
        </Box>

        <Button
          variant="contained"
          color="primary"
          onClick={() => saveProducts(products)}
        >
          儲存
        </Button>
      </Box>
      <Paper variant="outlined" sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>圖片</TableCell>
                <TableCell>名稱</TableCell>
                <TableCell>價格</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {products.map((product: any) => (
                <TableRow
                  key={product.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell sx={{ width: 140 }}>
                    <InputImageCell
                      imageUrl={product.image}
                      onFileChange={(file) => {
                        if (file) {
                          const url = URL.createObjectURL(file);
                          handleProductChange(product.id, "image", url);
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <InputCell
                      value={product.name}
                      onChange={(value) =>
                        handleProductChange(product.id, "name", value)
                      }
                    />
                  </TableCell>
                  <TableCell sx={{ width: 160 }}>
                    <InputCell
                      type="number"
                      value={product.price}
                      onChange={(value) =>
                        handleProductChange(product.id, "price", value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={() => {
                        const newProducts = products.filter(
                          (p: any) => p.id !== product.id,
                        );
                        setProducts(newProducts);
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default TabProducts;
